/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createMerchant} from '../api'

export const useMutationCreateMerchant = createReactQueryMutationHook('createMerchant', createMerchant)
